import { FC } from 'react';

import clsx from 'clsx';
import { MdClose } from 'react-icons/md';

import Jpeg from '@imgs/docs/jpeg.png';
import Pdf from '@imgs/docs/pdf.svg';
import { Box, ActionIcon, Text, Group, Image } from '@ui';
import { formatBytes } from '@utils';
import { getMimeInfo } from '@utils/mimetypes';

import classes from '../styles/FileItem.module.css';

interface FileItemProps {
  fileName: string;
  fileItem: File;
  isPasswordProtectedFile: boolean;
  isActive: boolean;
  onFileClick: () => void;
  onFileRemove: (
    filename: string
  ) => (e: React.MouseEvent<HTMLButtonElement>) => void;
  fileCountText: string;
}

const FileItem: FC<FileItemProps> = ({
  fileName,
  fileItem,
  isPasswordProtectedFile,
  isActive,
  onFileClick,
  onFileRemove,
  fileCountText
}) => {
  const fileInfo = getMimeInfo(fileItem.type);
  const imageIcon = fileInfo?.type === 'document' ? Pdf : Jpeg;
  return (
    <Box
      className={clsx(classes.fileInfo, {
        [classes.active]: isActive,
        [classes.protectedFile]: isPasswordProtectedFile
      })}
      onClick={onFileClick}
    >
      <Group gap={8} h={40} wrap="nowrap" align="flex-start">
        <Image src={imageIcon} h={32} w={32} />
        <Group gap={8} justify="space-between" flex={1} wrap="nowrap" align="center">
          <Box w={'100%'}>
            <Box fz={14} fw={600} className={classes.fileName} title={fileName}>
              {fileName}
            </Box>
            <Group align="center">
              <Text fz={14}>{fileCountText}</Text>
              <Box component="span" w={4} h={4} className={classes.dot} />
              <Text fz={14}>{formatBytes(fileItem.size)}</Text>
            </Group>
          </Box>
          <ActionIcon
            onClick={onFileRemove(fileName)}
            variant="transparent"
            color="secondary"
            aria-label="Remove file"
          >
            <MdClose size={16} />
          </ActionIcon>
        </Group>
      </Group>
    </Box>
  );
};

export default FileItem;
